import {
	removeError,
	addError,
	validatePasswordValue
} from '../lib/forms';

let form,
	passwordError = 'Поле заполнено некорректно';

const init = () => {
	form = document.querySelector('.js-register-form');
	if (!form) return;

	let fieldsRequired = [
		'USER_PASSWORD',
		'USER_CONFIRM_PASSWORD'
	];

	fieldsRequired.forEach((fieldCode) => {
		let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
		if (!fieldElement) return;

		if (fieldCode === 'USER_PASSWORD' || fieldCode === 'USER_CONFIRM_PASSWORD') {
			fieldElement.addEventListener('input', function() {
				if (validatePasswordValue(fieldElement.value)) {
					removeError(fieldElement);
				}
			});
		}
	});

	// submit
	form.addEventListener('submit', (e) => {
		let hasErrors = false;

		fieldsRequired.forEach((fieldCode) => {
			let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
			if (!fieldElement) return;

			removeError(fieldElement);

			if (fieldCode === 'USER_PASSWORD' || fieldCode === 'USER_CONFIRM_PASSWORD') {
				if (!validatePasswordValue(fieldElement.value)) {
					addError(fieldElement, passwordError);
					hasErrors = true;
				}
			}
		});

		if (hasErrors) {
			e.preventDefault();
		}

		return hasErrors === false;
	});
};

export default {
	init
};